import React from 'react';
import { Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import Login from 'app/modules/login/login';
import Register from 'app/modules/account/register/register';
import Logout from 'app/modules/login/logout';
import Home from 'app/modules/home/home';
import EntitiesRoutes from 'app/entities/routes';
import PrivateRoute, { hasAnyAuthority } from 'app/shared/auth/private-route';
import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import PageNotFound from 'app/shared/error/page-not-found';
import { AUTHORITIES } from 'app/config/constants';
import { useAppSelector } from 'app/config/store';
import { Get2fa } from 'app/modules/tools/get2fa';
import { CheckLiveUid } from 'app/modules/tools/check-live-uid';
import { CheckLiveMail } from 'app/modules/tools/check-live-mail';
import { GetCodeMail } from 'app/modules/tools/get-code-mail';
import { ReadMail } from 'app/modules/tools/read-mail';
import { RegisterMail } from 'app/modules/tools/register-mail';
import { UnlockMail } from 'app/modules/tools/unlock-mail';
import { RegisterYahoo } from 'app/modules/tools/register-yahoo';
import { Term } from 'app/modules/term';
import { Policy } from 'app/modules/policy';
import PasswordResetInit from 'app/modules/account/password-reset/init/password-reset-init';
import PasswordResetFinish from 'app/modules/account/password-reset/finish/password-reset-finish';
import { Membership } from 'app/modules/membership/membership';

const loading = <div>loading ...</div>;

const Account = Loadable({
  loader: () => import(/* webpackChunkName: "account" */ 'app/modules/account'),
  loading: () => loading,
});

const Admin = Loadable({
  loader: () => import(/* webpackChunkName: "administration" */ 'app/modules/administration'),
  loading: () => loading,
});
const AppRoutes = () => {
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));

  return (
    <div className="view-routes">
      <ErrorBoundaryRoutes>
        <Route index element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="reset-pass" element={<PasswordResetInit />} />
        <Route path="reset-finish" element={<PasswordResetFinish />} />
        <Route path="logout" element={<Logout />} />
        <Route path="get2fa" element={<Get2fa />} />
        <Route path="check-live-uid" element={<CheckLiveUid />} />
        <Route path="check-live-mail" element={<CheckLiveMail />} />
        <Route path="get-code-mail" element={<GetCodeMail />} />
        <Route path="read-mail-box" element={<ReadMail />} />
        <Route path="register-mail" element={<RegisterMail />} />
        <Route path="unlock-mail" element={<UnlockMail />} />
        <Route path="register-yahoo" element={<RegisterYahoo />} />
        <Route path="terms-of-service" element={<Term />} />
        <Route path="policy" element={<Policy />} />
        <Route path="membership" element={<Membership />} />
        <Route path="account">
          <Route
            path="*"
            element={
              <PrivateRoute hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.USER]}>
                <Account />
              </PrivateRoute>
            }
          />
          <Route path="register" element={<Register />} />
          {/* <Route path="activate" element={<Activate />} />*/}
          {/* <Route path="reset">*/}
          {/*  <Route path="request" element={<PasswordResetInit/>}/>*/}
          {/*  <Route path="finish" element={<PasswordResetFinish/>}/>*/}
          {/* </Route>*/}
        </Route>
        <Route
          path="admin/*"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.ADMIN]}>
              <Admin />
            </PrivateRoute>
          }
        />
        <Route
          path="*"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <EntitiesRoutes />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default AppRoutes;
